import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Create an account", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body" }, "Please provide the email address to which your credit card is registered.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Form, {
      fields: _ctx.fields,
      buttons: _ctx.buttons,
      onFormHasPassedValidation: _ctx.saveFormData
    }, null, 8, ["fields", "buttons", "onFormHasPassedValidation"])
  ], 64))
}